import { useMutation } from "react-query";
import { api } from "../api";
import { usePaymentContext } from "../../context/paymentContext";
import { useNavigate } from "react-router-dom";

export function useApiRegisters() {
  const { handlePreferenceId, handleIsNotified, handleSetDataClient } =
    usePaymentContext();
  const navigate = useNavigate();

  const { mutate: sendPreRegister, isLoading: isLoadingPreRegister } =
    useMutation(
      "registers",
      async ({ data }) => {
        return api
          .post("/clients/preregister", data)
          .then((response) => response.data);
      },
      {
        onSuccess: (data) => {
          console.log("onSucess - resposta do backend:", data);
          console.log("onSucess - dados originais do localStorage:", localStorage.getItem('clientData'));
          
          handlePreferenceId(data.preference_id);
          
          // Recuperar dados originais do localStorage
          const originalClientData = JSON.parse(localStorage.getItem('clientData') || '{}');
          console.log("onSucess - dados originais parseados:", originalClientData);
          
          // Mesclar com dados do backend se necessário
          const finalClientData = {
            ...originalClientData,
            preference_id: data.preference_id
          };
          
          console.log("onSucess - dados finais:", finalClientData);
          handleSetDataClient(finalClientData);
          
          data.FormOfPayment === "digital"
            ? navigate("/checkout")
            : navigate("/success_pre_register");
        },
        onError: () => {
          handleIsNotified({
            label: "Ops! tivemos um erro ao enviar sua inscrição.",
            type: "error",
          });
        },
      }
    );

  return { sendPreRegister, isLoadingPreRegister };
}
